import { useEffect, useRef, type RefObject } from 'react';
import type { CheckoutOutcome } from './useCheckoutFrameEvents';

/** A terminal report closes the dialog and can remove the control that opened
 *  it, so the status left behind takes focus rather than the document body. */
export function useCheckoutOutcomeFocus(
    outcome: CheckoutOutcome | null,
    statusRef: RefObject<HTMLElement | null>,
): void {
    const previousOutcome = useRef(outcome);

    useEffect(() => {
        const changed = previousOutcome.current !== outcome;
        previousOutcome.current = outcome;
        // Only the success path loses its opener: a failure leaves Retry payment
        // in the same slot, which the dialog restores focus to on its own.
        if (changed && outcome === 'completed') statusRef.current?.focus();
    }, [outcome, statusRef]);
}
